import React, { useEffect, useRef, useState } from 'react'
import css from './cropmodal.scss'
import GlobalModal from './GlobalModal'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import Button from '../atoms/Button'
import S3 from 'react-aws-s3'
import dataURLtoBlob from 'dataurl-to-blob'
import { handleToast } from 'src/slices/utils'
window.Buffer = window.Buffer || require('buffer').Buffer

function CropModal({ closeFunction, image, hadnlecropped: handleCropped }) {
	const config = {
		bucketName: 'carty-app',
		region: 'us-east-1',
		accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
		secretAccessKey: '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',
		s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
	}
	const [converted, setConverted] = useState()
	useEffect(() => {
		if (image) {
			const reader = new FileReader()
			reader.onload = () => {
				setConverted(reader.result)
			}
			reader.readAsDataURL(image)
		}
	}, [image])
	const [cropped, setCropped] = useState()

	const cropperRef = useRef()

	const onCrop = () => {
		const imageElement = cropperRef?.current
		const cropper = imageElement?.cropper
		let imageUrl = dataURLtoBlob(cropper.getCroppedCanvas().toDataURL())
		setCropped(imageUrl)
	}
	const handleSave = () => {
		const ReactS3Client = new S3(config)
		const uploadImage = ReactS3Client.uploadFile(cropped, image.name).then(data => {
			handleCropped(data.location)
		})

		handleToast(uploadImage, {
			isSuccess: { message: 'Image Uploaded!' },
			isError: { message: 'Image could not be uploaded, please try again.' },
			isLoading: { message: `Uploading...` },
		})
	}

	return (
		<GlobalModal
			title={'Crop Image'}
			closeFunction={closeFunction}
			buttons={
				<>
					<Button label='Save' action={handleSave}></Button>
				</>
			}>
			<Cropper
				src={converted}
				style={{ height: 400, width: '100%' }}
				// Cropper.js options
				initialAspectRatio={16 / 9}
				guides={false}
				crop={onCrop}
				ref={cropperRef}
			/>
		</GlobalModal>
	)
}

export default CropModal
